module.exports = __webpack_public_path__ + "img/Orb_Label_Text_Math.3c38c6a1.png";